import { defineMessages } from 'react-intl';

export const languageMessages = defineMessages({
    english: {
        id: 'english',
        defaultMessage: 'English',
    },
    bulgarian: {
        id: 'bulgarian',
        defaultMessage: 'Bulgarian',
    },
});

export const generalErrorMessages = defineMessages({
    somethingWentWrong: {
        id: 'something-went-wrong',
        defaultMessage: 'Something went wrong',
    },
    somethingWentWrongRetry: {
        id: 'something-went-wrong-retry',
        defaultMessage: 'Please retry again later or contact an administrator',
    },
    unknownError: {
        id: 'unknown-error',
        defaultMessage: 'An unknown error occurred',
    },
    error: {
        id: 'error',
        defaultMessage: 'Error',
    },
});

export const generalValidationMessages = defineMessages({
    fieldRequired: {
        id: 'field-required',
        defaultMessage: 'This field is required',
    },
    fieldInvalidMinLength: {
        id: 'field-invalid-min-length',
        defaultMessage: 'Minimum field length is {min} symbols',
    },
    fieldInvalidMaxLength: {
        id: 'field-invalid-max-length',
        defaultMessage: 'Maximum field length is {max} symbols',
    },
    fieldInvalidMaxValue: {
        id: 'field-invalid-max-value',
        defaultMessage: 'Maximum field value is {max}',
    },
    fieldRequiredSelect: {
        id: 'field-required-select',
        defaultMessage: 'Please select a value',
    },
    fieldRequiredArray: {
        id: 'field-required-array',
        defaultMessage: 'Please select at least one value',
    },
    fieldRequiredDate: {
        id: 'field-required-date',
        defaultMessage: 'Please select a date',
    },
    fieldInvalidTime: {
        id: 'field-required-time',
        defaultMessage: 'Please enter a valid time',
    },
    fieldInvalidEmail: {
        id: 'field-invalid-email',
        defaultMessage: 'Please enter a valid email address',
    },
    selectCurrency: {
        id: 'select-currency',
        defaultMessage: 'Select currency',
    },
    selectCity: {
        id: 'select-city',
        defaultMessage: 'Select city',
    },
});

export const generalMessages = defineMessages({
    dashboard: {
        id: 'dashboard',
        defaultMessage: 'Dashboard',
    },
    missingEntry: {
        id: 'missing-entry',
        defaultMessage: 'Missing entry',
    },
    service: {
        id: 'service',
        defaultMessage: 'Service',
    },
    message: {
        id: 'message',
        defaultMessage: 'Message',
    },
    entry: {
        id: 'entry',
        defaultMessage: 'Entry',
    },
    or: {
        id: 'or',
        defaultMessage: 'or',
    },
    exit: {
        id: 'exit',
        defaultMessage: 'Exit',
    },
    confirm: {
        id: 'confirm',
        defaultMessage: 'Confirm',
    },
    loading: {
        id: 'loading',
        defaultMessage: 'Loading...',
    },
    unknown: {
        id: 'unknown',
        defaultMessage: 'Unknown',
    },
    vehicles: {
        id: 'vehicles',
        defaultMessage: 'Vehicles',
    },
    vehicle: {
        id: 'vehicle',
        defaultMessage: 'Vehicle',
    },
    memberships: {
        id: 'memberships',
        defaultMessage: 'Memberships',
    },
    reason: {
        id: 'reason',
        defaultMessage: 'Reason',
    },
    location: {
        id: 'location',
        defaultMessage: 'Location',
    },
    validFrom: {
        id: 'valid-from',
        defaultMessage: 'Valid from',
    },
    validTo: {
        id: 'valid-to',
        defaultMessage: 'Valid to',
    },
    pickADate: {
        id: 'pick-a-date',
        defaultMessage: 'Pick a date',
    },
    month: {
        id: 'month',
        defaultMessage: 'Month',
    },
    months: {
        id: 'months',
        defaultMessage: 'Months',
    },
    year: {
        id: 'year',
        defaultMessage: 'Year',
    },
    selectPeriod: {
        id: 'select-period',
        defaultMessage: 'Select period',
    },
    selectAll: {
        id: 'select-all',
        defaultMessage: 'Select all',
    },
    deselectAll: {
        id: 'deselect-all',
        defaultMessage: 'Deselect all',
    },
    expired: {
        id: 'expired',
        defaultMessage: 'Expired',
    },
    owner: {
        id: 'owner',
        defaultMessage: 'Owner',
    },
    new: {
        id: 'new',
        defaultMessage: 'New',
    },
    save: {
        id: 'save',
        defaultMessage: 'Save',
    },
    cancel: {
        id: 'cancel',
        defaultMessage: 'Cancel',
    },
    delete: {
        id: 'delete',
        defaultMessage: 'Delete',
    },
    copy: {
        id: 'copy',
        defaultMessage: 'Copy',
    },
    resend: {
        id: 'resend',
        defaultMessage: 'Resend',
    },
    status: {
        id: 'status',
        defaultMessage: 'Status',
    },
    timestamp: {
        id: 'timestamp',
        defaultMessage: 'Timestamp',
    },
    created: {
        id: 'created',
        defaultMessage: 'Created',
    },
    edit: {
        id: 'edit',
        defaultMessage: 'Edit',
    },
    last24Hours: {
        id: 'last-24-hours',
        defaultMessage: 'Last 24 hours',
    },
    name: {
        id: 'name',
        defaultMessage: 'Name',
    },
    saveChanges: {
        id: 'save-changes',
        defaultMessage: 'Save changes',
    },
    address: {
        id: 'address',
        defaultMessage: 'Address',
    },
    country: {
        id: 'country',
        defaultMessage: 'Country',
    },
    city: {
        id: 'city',
        defaultMessage: 'City',
    },
    overview: {
        id: 'overview',
        defaultMessage: 'Overview',
    },
    custom: {
        id: 'custom',
        defaultMessage: 'Custom',
    },
    viewAll: {
        id: 'view-all',
        defaultMessage: 'View all',
    },
    warnings: {
        id: 'warnings',
        defaultMessage: '{count, plural, one {{count, number} Warning} other {{count, number} Warnings}}',
    },
    crititalErrors: {
        id: 'criticalErrors',
        defaultMessage: '{count, plural, one {{count, number} Critical error} other {{count, number} Critical errors}}',
    },
    execute: {
        id: 'execute',
        defaultMessage: 'Execute',
    },
    send: {
        id: 'send',
        defaultMessage: 'Send',
    },
    close: {
        id: 'close',
        defaultMessage: 'Close',
    },
    timeline: {
        id: 'timeline',
        defaultMessage: 'Timeline',
    },
    oneWeek: {
        id: 'one-week',
        defaultMessage: '1 week',
    },
    oneMonth: {
        id: 'one-month',
        defaultMessage: '1 month',
    },
    threeMonths: {
        id: 'three-months',
        defaultMessage: '3 months',
    },
    oneYear: {
        id: 'one-year',
        defaultMessage: '1 year',
    },
    indefinite: {
        id: 'indefinite',
        defaultMessage: 'Indefinite',
    },
    submit: {
        id: 'submit',
        defaultMessage: 'Submit',
    },
    noOptions: {
        id: 'no-options',
        defaultMessage: 'No options found',
    },
    altImagePlaceholder: {
        id: 'alt-image-placeholder',
        defaultMessage: 'Image placeholder',
    },
    yes: {
        id: 'yes',
        defaultMessage: 'Yes',
    },
    no: {
        id: 'no',
        defaultMessage: 'No',
    },
    days: {
        id: 'days',
        defaultMessage: 'Days',
    },
    hours: {
        id: 'hours',
        defaultMessage: 'Hours',
    },
    minutes: {
        id: 'minutes',
        defaultMessage: 'Minutes',
    },
    smartPark: {
        id: 'smartpark',
        defaultMessage: 'SmartPark',
    },
    deactivate: {
        id: 'deactivate',
        defaultMessage: 'Deactivate',
    },
    activate: {
        id: 'activate',
        defaultMessage: 'Activate',
    },
    selectValue: {
        id: 'selectValue',
        defaultMessage: 'Select value',
    },
    noValue: {
        id: 'no-value',
        defaultMessage: 'No value',
    },
    chargePlanForLateNotFound: {
        id: 'charge-plan-for-late-not-found',
        defaultMessage: 'Charge plan for late not found!',
    },
    errorConnectToParking: {
        id: 'error-connect-to-parking',
        defaultMessage: 'Something went wrong when trying to reach the parking',
    },
    exportCSV: {
        id: 'export-csv',
        defaultMessage: 'Export to csv',
    },
    successfulCreate: {
        id: 'successful-create',
        defaultMessage: 'Successful create',
    },
    successfulEdit: {
        id: 'successful-edit',
        defaultMessage: 'Successful edit',
    },
    successfulDelete: {
        id: 'successful-delete',
        defaultMessage: 'Successful delete',
    },
    online: {
        id: 'online',
        defaultMessage: 'Online',
    },
    offline: {
        id: 'offline',
        defaultMessage: 'Offline',
    },
    notApplicable: {
        id: 'not-applicable',
        defaultMessage: 'N/A',
    },
    editEntry: {
        id: 'edit-entry',
        defaultMessage: 'Edit {entry}',
    },
    deleteEntry: {
        id: 'delete-entry',
        defaultMessage: 'Delete {entry}',
    },
    createEntry: {
        id: 'create-entry',
        defaultMessage: 'Create {entry}',
    },
});

export const generalMessagesDays = defineMessages({
    monday: {
        id: 'monday',
        defaultMessage: 'Monday',
    },
    tuesday: {
        id: 'tuesday',
        defaultMessage: 'Tuesday',
    },
    wednesday: {
        id: 'wednesday',
        defaultMessage: 'Wednesday',
    },
    thursday: {
        id: 'thursday',
        defaultMessage: 'Thursday',
    },
    friday: {
        id: 'friday',
        defaultMessage: 'Friday',
    },
    saturday: {
        id: 'saturday',
        defaultMessage: 'Saturday',
    },
    sunday: {
        id: 'sunday',
        defaultMessage: 'Sunday',
    },
});

export const generalLabelMessages = defineMessages({
    details: {
        id: 'details',
        defaultMessage: 'Details',
    },
    additionalInformation: {
        id: 'additional-information',
        defaultMessage: 'Additional information',
    },
    pickDateRange: {
        id: 'pick-date-range',
        defaultMessage: 'Pick a date range',
    },
});

export const generalPriceMessages = defineMessages({
    price: {
        id: 'price',
        defaultMessage: 'Price',
    },
    pricing: {
        id: 'pricing',
        defaultMessage: 'Pricing',
    },
    vat: {
        id: 'vat',
        defaultMessage: 'VAT',
    },
    vatAmount: {
        id: 'vat-amount',
        defaultMessage: 'VAT amount',
    },
    priceWithVat: {
        id: 'price-with-vat',
        defaultMessage: 'Price with VAT',
    },
    priceWithoutVat: {
        id: 'reservation-price-without-vat',
        defaultMessage: 'Price without VAT',
    },
    currency: {
        id: 'currency',
        defaultMessage: 'Currency',
    },
});

// Basically zod doesn't allow objects as messages, so we have to somehow
// be able to define these messages outside of the react component lifecycle.
// This is a workaround for that. You can find in src/components/Form.tsx -
// FormMessage how we search for these messages inside this object only.
// It is a bit hacky but it is the only way to achieve it with zod and being able
// to contain the zod schema in the same file as the react query hooks.
export const validationMessages = defineMessages({
    validationErrorConfirmPassword: {
        id: 'validation-error-confirm-password',
        defaultMessage: 'Passwords do not match',
    },
    validationErrorFirstName: {
        id: 'validation-error-first-name',
        defaultMessage: 'First name must be between 3 and 24 characters',
    },
    validationErrorLastName: {
        id: 'validation-error-last-name',
        defaultMessage: 'Last name must be between 3 and 24 characters',
    },
    validationErrorName: {
        id: 'validation-error-name',
        defaultMessage: 'Name must be between 3 and 50 characters',
    },
    validationErrorEmail: {
        id: 'validation-error-email',
        defaultMessage: 'Please enter a valid email address',
    },
    validationErrorPassword: {
        id: 'validation-error-password',
        defaultMessage: '8 characters, 1 lowercase, 1 uppercase, 1 number',
    },
    validationErrorRequired: {
        id: 'required-field',
        defaultMessage: 'Required',
    },
    validationErrorOldPassword: {
        id: 'validation-error-old-password',
        defaultMessage: 'Old password is incorrect',
    },
    validationErrorPricingPlanName: {
        id: 'validation-error-pricing-plan-name',
        defaultMessage: 'The name must be at least 5 characters long',
    },
});

type ValidationMessagesKeys = keyof typeof validationMessages;

type ValidationMessagesMap = {
    [key in ValidationMessagesKeys]: key;
};

export const validationMessagesMap = (Object.keys(validationMessages) as Array<ValidationMessagesKeys>).reduce(
    (acc: ValidationMessagesMap, keyMap: ValidationMessagesKeys) => {
        // @ts-expect-error Can't figure out how to bypass ts error here
        acc[keyMap] = keyMap;
        return acc;
    },
    {} as ValidationMessagesMap,
);

export const offlineMessages = defineMessages({
    parkingOffline: {
        id: 'parking-offline',
        defaultMessage: 'Parking is offline',
    },
    parkingOfflineDescription: {
        id: 'parking-offline-description',
        defaultMessage: 'The parking you are trying to connect to seems to be offline. Please try reconnecting to it.',
    },
    reconnect: {
        id: 'reconnect',
        defaultMessage: 'Reconnect',
    },
});
